import { z } from 'zod';

/**
 * Client-side validation for the auth screens. Clerk validates again on
 * submit (password strength, breached passwords); its errors land on the same
 * fields.
 */
const email = z.email('Enter a valid email address');
const newPassword = z.string().min(15, 'Use at least 15 characters');
const matches = (v: { password: string; confirm: string }) => v.password === v.confirm;
const mismatch = { path: ['confirm'], message: 'Passwords don’t match' };

export const SignInSchema = z.object({
  email,
  password: z.string().min(1, 'Enter your password'),
});
export type SignInValues = z.infer<typeof SignInSchema>;

export const SignUpSchema = z
  .object({
    name: z.string().trim().min(1, 'Enter your full name'),
    email,
    password: newPassword,
    confirm: z.string(),
    terms: z.boolean().refine(Boolean, 'Accept the Terms and Privacy Policy to continue'),
  })
  .refine(matches, mismatch);
export type SignUpValues = z.infer<typeof SignUpSchema>;

export const ForgotPasswordSchema = z.object({ email });
export type ForgotPasswordValues = z.infer<typeof ForgotPasswordSchema>;

export const ResetPasswordSchema = z
  .object({ password: newPassword, confirm: z.string() })
  .refine(matches, mismatch);
export type ResetPasswordValues = z.infer<typeof ResetPasswordSchema>;

export const CodeSchema = z.object({
  code: z.string().regex(/^\d{6}$/, 'Enter the six-digit code from your app'),
});
export type CodeValues = z.infer<typeof CodeSchema>;

export const EmailCodeSchema = z.object({
  code: z.string().regex(/^\d{6}$/, 'Enter the six-digit code from the email'),
});
